import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteSubscription } from './subscriptions.service'

export const useSubscriptionDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteSubscription,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['subscriptions', vars.entityId],
      })
    },
  })
}
